import { getConstantValue } from './vernacularStrings';

const constants = getConstantValue();
export default constants;
